import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';

export interface Community {
    name: string;
    id: string;
}

export interface CheckApiResponse {
    Communities: Array<{
        [key: string]: Community;
    }>;
}

@Injectable({
    providedIn: 'root'
})
export class DataService {
    constructor(
        private http: HttpClient,
        private environmentService: EnvironmentService
    ) {}

    checkApi(): Observable<CheckApiResponse> {
        return this.http.get<CheckApiResponse>(`${this.environmentService.getBffApiUrl()}/sample/check-api`);
    }
}
